module.exports = __webpack_public_path__ + "static/media/3.e2dd61c0.svg";